"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSurveySubmitAction = exports.createSurveyCard = exports.createScheduleContainer = exports.createSurveyContainer = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../../_shared/commands");
const components_1 = require("../../_shared/components");
const PageIndicator_1 = require("../../_shared/components/PageIndicator");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
function createSurveyContainer(survey, containerParams) {
    return createContainer(survey.title, survey.type, survey.questions, (0, components_1.detailsBar)(survey, { separator: true }), containerParams, survey.description);
}
exports.createSurveyContainer = createSurveyContainer;
function createScheduleContainer(scheduleInfo, containerParams) {
    return createContainer(scheduleInfo.name, scheduleInfo.templateType, scheduleInfo.questions, (0, components_1.scheduleDetailsBar)(scheduleInfo, { separator: true }), containerParams, scheduleInfo.description);
}
exports.createScheduleContainer = createScheduleContainer;
function createContainer(title, type, questions, details, { showHeader, questionIndex, highlighRequiredQIds, maxQuestionDisplay, existingResponse, hideDetailsBar, }, description) {
    const container = new adaptivecards_1.Container();
    if (showHeader) {
        const topContainer = new adaptivecards_1.Container();
        topContainer.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            size: adaptivecards_1.TextSize.Large,
            weight: adaptivecards_1.TextWeight.Bolder,
            text: title,
            spacing: adaptivecards_1.Spacing.Medium,
            color: adaptivecards_1.TextColor.Accent,
            wrap: true,
        }));
        if (description) {
            topContainer.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
                size: adaptivecards_1.TextSize.Small,
                text: description,
                spacing: adaptivecards_1.Spacing.Medium,
                wrap: true,
            }));
        }
        container.addItem(topContainer);
    }
    if (!hideDetailsBar) {
        container.addItem(details);
    }
    let maxDisplay = maxQuestionDisplay || questions.length;
    if (maxDisplay > questions.length) {
        maxDisplay = questions.length;
    }
    let max = questionIndex + maxDisplay;
    if (max >= questions.length) {
        max = questions.length;
    }
    const questionIds = [];
    for (let i = questionIndex; i < max; i++) {
        const question = questions[i];
        let qr;
        if (existingResponse) {
            qr = existingResponse.responses.find(q => q.questionId === question.id);
        }
        const highlightRequired = highlighRequiredQIds && highlighRequiredQIds.indexOf(question.id) >= 0;
        container.addItem((0, components_1.questionTakingContainer)(question, i + 1, {
            highlightRequired,
            hideTitle: type === "poll",
        }, qr === null || qr === void 0 ? void 0 : qr.value, qr === null || qr === void 0 ? void 0 : qr.comment));
        questionIds.push(question.id);
    }
    return {
        container,
        questionIds,
    };
}
function createSurveyCard(survey, { showHeader, highlighRequiredQIds, questionIndexId, maxQuestionDisplay, existingResponse, hideDetailsBar, }) {
    const card = CardHelper_1.CardHelper.newCard();
    if (!questionIndexId) {
        questionIndexId = survey.questions[0].id;
    }
    let questionIndex = survey.questions.findIndex(q => q.id === questionIndexId);
    if (questionIndex === -1) {
        questionIndex = 1;
    }
    const { container, questionIds } = createSurveyContainer(survey, {
        showHeader,
        questionIndex,
        highlighRequiredQIds,
        maxQuestionDisplay,
        existingResponse,
        hideDetailsBar,
    });
    card.addItem(container);
    const pages = Math.ceil(survey.questions.length / maxQuestionDisplay);
    if (pages > 1) {
        const curPage = Math.floor(questionIndex / maxQuestionDisplay);
        card.addItem((0, PageIndicator_1.PageIndicator)(survey.id, curPage, pages, undefined, survey.applicationType));
        if (curPage > 0) {
            card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
                // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
                title: "❮ Previous",
                data: (0, commands_1.takingSubmitCommand)(survey.id, questionIndexId, questionIds, "previous").toTaskFetchCommand(),
            }));
        }
    }
    const hasMore = questionIndex + questionIds.length < survey.questions.length;
    const submitButton = createSurveySubmitAction(survey.id, hasMore, questionIndexId, questionIds);
    card.addAction(submitButton);
    return card;
}
exports.createSurveyCard = createSurveyCard;
function createSurveySubmitAction(surveyId, isNextButton, questionIndexId, questionIds) {
    // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
    const submitResponseButtonLabel = "Submit response";
    // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
    const NextButtonLabel = "Next ❯";
    return CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: isNextButton ? NextButtonLabel : submitResponseButtonLabel,
        data: (0, commands_1.takingSubmitCommand)(surveyId, questionIndexId, questionIds).toTaskFetchCommand(),
    });
}
exports.createSurveySubmitAction = createSurveySubmitAction;
//# sourceMappingURL=Survey.js.map